import { Image } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import React from 'react';

import { Card } from '@hero/components/atoms';

import * as S from './style';

function CardMessage({ greetingCard, giftWrapperUrl, logoUrl }) {
  return greetingCard ? (
    <S.CardMessageWrapper giftWrapperUrl={giftWrapperUrl}>
      <Card style={{ padding: 4 }}>
        <Image src={greetingCard?.card_image} />
      </Card>
    </S.CardMessageWrapper>
  ) : (
    <S.CardMessageEmptyStateWrapper giftWrapperUrl={giftWrapperUrl}>
      <S.ExperienceBowImage name="experienceBow" />
      <S.ExperienceCardImage name="experienceCard" />
      {logoUrl && <S.LogoImage logoUrl={logoUrl} />}
    </S.CardMessageEmptyStateWrapper>
  );
}

CardMessage.propTypes = {
  greetingCard: PropTypes.shape({ card_image: PropTypes.string }),
  giftWrapperUrl: PropTypes.string,
  logoUrl: PropTypes.string
};

export { CardMessage };
